import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface GridPosition {
    x: number;
    y: number;
}

export interface ApplicationGridPositions {
    [applicationId: string]: GridPosition;
}

export interface UserSettings {
    id?: string;
    theme: "light" | "dark";
    language: string;
    notifications: boolean;
    applicationGridPositions: ApplicationGridPositions;
}

interface UserSettingsState {
    settings: UserSettings;
    isLoading: boolean;
    error: string | null;
}

const initialState: UserSettingsState = {
    settings: {
        theme: "light",
        language: "en",
        notifications: true,
        applicationGridPositions: {},
    },
    isLoading: false,
    error: null,
};

const userSettingsSlice = createSlice({
    name: "userSettings",
    initialState,
    reducers: {
        setSettings: (state, action: PayloadAction<UserSettings>) => {
            state.settings = action.payload;
            state.error = null;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
        },
        updateApplicationGridPosition: (state, action: PayloadAction<{ applicationId: string; position: GridPosition }>) => {
            state.settings.applicationGridPositions[action.payload.applicationId] = action.payload.position;
        },
    },
});

export const { setSettings, setLoading, setError, updateApplicationGridPosition } = userSettingsSlice.actions;
export default userSettingsSlice.reducer;
